import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ml from './locales/ml.json'

export interface SupportedLocale {
  code: string
  name: string
  nativeName: string
}

export const SUPPORTED_LOCALES: SupportedLocale[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
]

export function getStoredLocale(): string {
  const stored = localStorage.getItem('health-monitor-locale')
  if (stored && SUPPORTED_LOCALES.some(l => l.code === stored)) {
    return stored
  }
  const browserLang = navigator.language.split('-')[0]
  if (SUPPORTED_LOCALES.some(l => l.code === browserLang)) {
    return browserLang
  }
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: { en, ml },
})

export default i18n
